export const answerModule = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00,
  0x01, 0x05, 0x01, 0x60, 0x00, 0x01, 0x7f,
  0x03, 0x02, 0x01, 0x00,
  0x07, 0x0a, 0x01, 0x06, 0x61, 0x6e, 0x73, 0x77, 0x65, 0x72, 0x00, 0x00,
  0x0a, 0x06, 0x01, 0x04, 0x00, 0x41, 0x2a, 0x0b,
]);

// (module (memory i64 1)); the memory64 flag is bit 2 of the memory limits.
export const memory64Module = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00,
  0x05, 0x03, 0x01, 0x04, 0x01,
]);

export async function runDynamicWasmProbe(): Promise<number> {
  const module = await WebAssembly.compile(answerModule);
  const instance = await WebAssembly.instantiate(module);
  const answer = instance.exports.answer;
  if (typeof answer !== "function") throw new Error("answer export is missing");
  return Number(answer());
}

export function supportsMemory64(): boolean {
  return typeof WebAssembly === "object" && WebAssembly.validate(memory64Module);
}
